import { useMapContext } from '@rio-cloud/rio-uikit/MapContext';
import { useEffect } from 'react';

import type { Position } from './types';

const POSITION_EPSILON = 1e-6;

interface CenterMapOnPositionProps {
    center?: Position;
    animate?: boolean;
}

const CenterMapOnPosition = ({ center, animate = false }: CenterMapOnPositionProps) => {
    const { api } = useMapContext();
    const utils = api.utils;

    useEffect(() => {
        if (!center || !utils) {
            return;
        }

        const current = utils.getCenter();
        const isAlreadyCentred =
            Math.abs(current.lat - center.lat) < POSITION_EPSILON &&
            Math.abs(current.lng - center.lng) < POSITION_EPSILON;

        if (isAlreadyCentred) {
            return;
        }

        utils.setCenter(center, animate);
    }, [utils, center, animate]);

    return null;
};

export default CenterMapOnPosition;
